import React, { useEffect, useState} from "react";
import {
  Form,
  Input,
  InputNumber,
  Button,
  Checkbox,
  Row,
  Col,
} from "antd";

const RecRegistrationForm = ({
  onSubmit,
  formData,
  setFormData,
}) =>  {
  const [form] = Form.useForm();
  const [isNameFocused, setIsNameFocused] = useState(false);

  useEffect(() => {
    form.setFieldsValue(formData);
  }, [formData, form]);

  const handleFinish = (values) => {
    onSubmit(values);
  };

  const handleValuesChange = (_, allValues) => {
    setFormData(allValues);
  };

  return (
    <div className="rec-registration-container">
      <div className="rec-form-title">
        Payment Collection
      </div>

      <Form
        form={form}
        layout="vertical"
        initialValues={formData}
        onValuesChange={handleValuesChange}
        onFinish={handleFinish}
        className="rec-registration-form"
      >
        <Form.Item
          label="Full Name"
          name="full_name"
          extra={
            isNameFocused ? (
              <span style={{ color: "#faad14" }}>
                Name should be the same as <strong>Applicant Name</strong>.
              </span>
            ) : null
          }
          rules={[
            {
              required: true,
              message: "Please enter full name",
            },
            {
              max: 150,
              message: "Name cannot exceed 150 characters",
            },
          ]}
        >
          <Input
            size="large"
            maxLength={150}
            placeholder="Enter Full Name"
            onFocus={() => setIsNameFocused(true)}
            onBlur={() => setIsNameFocused(false)}
          />
        </Form.Item>

        <Form.Item
          label="Mobile Number"
          name="mobile"
          rules={[
            {
              required: true,
              message: "Please enter mobile number",
            },
            {
              pattern: /^[6-9]\d{9}$/,
              message: "Please enter valid mobile number",
            },
          ]}
        >
          <Input
            size="large"
            maxLength={10}
            placeholder="Enter Mobile Number"
          />
        </Form.Item>

        <Form.Item
          label="Email ID"
          name="email"
          rules={[
            {
              required: true,
              message: "Please enter email",
            },
            {
              type: "email",
              message: "Please enter valid email",
            },
          ]}
        >
          <Input
            size="large"
            placeholder="Enter Email ID"
          />
        </Form.Item>

        <Form.Item
          label="PAN"
          name="pan"
          normalize={(value) =>
            value ? value.toUpperCase() : value
          }
          rules={[
            {
              required: true,
              message: "Please enter PAN",
            },
            {
              pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
              message: "Please enter valid PAN",
            },
          ]}
        >
          <Input
            size="large"
            maxLength={10}
            placeholder="Enter PAN"
          />
        </Form.Item>

        <Form.Item
          label="Amount Column (Min ₹20000, Max ₹50 Lac)"
          name="amount"
          rules={[
            {
              required: true,
              message: "Please enter amount",
            },
            {
              validator: (_, value) => {
                if (!value) {
                  return Promise.resolve();
                }

                if (value < 20000) {
                  return Promise.reject(
                    new Error("Minimum amount allowed is ₹20,000")
                  );
                }

                if (value > 5000000) {
                  return Promise.reject(
                    new Error("Maximum amount allowed is ₹50,00,000")
                  );
                }

                if (value % 10000 !== 0) {
                  return Promise.reject(
                    new Error(
                      "Amount should be in multiples of ₹10,000"
                    )
                  );
                }

                return Promise.resolve();
              },
            },
          ]}
        >
          <InputNumber
            size="large"
            controls
            step={10000}
            style={{ width: "100%" }}
            placeholder="Enter Amount"
            formatter={(value) =>
              value
                ? `₹ ${Number(value).toLocaleString("en-IN")}`
                : ""
            }
            parser={(value) =>
              value ? value.replace(/[₹,\s]/g, "") : ""
            }
          />
        </Form.Item>

        <div className="rec-terms-section">
          <Form.Item
            name="consent"
            valuePropName="checked"
            rules={[
              {
                validator: (_, value) =>
                  value
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error(
                          "Please accept Terms & Conditions"
                        )
                      ),
              },
            ]}
          >
            <Checkbox>
              I have read and agree to the Terms and Conditions and consent to REC Limited storing my information in accordance with applicable regulations.
            </Checkbox>
          </Form.Item>

          <div className="rec-terms-heading">
            Terms & Conditions
          </div>

          <ul className="rec-terms-list">
            <li>
              <a
                href="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/Term_sheet.pdf"
                target="_blank"
                rel="noreferrer"
              >
                Term Sheet – Series XX
              </a>
            </li>

            <li>
              <a
                href="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/Information_Memorandum_REC_Section_85_Bonds_Series_XX_31_March_2026.pdf"
                target="_blank"
                rel="noreferrer"
              >
                Information Memorandum – Series XX
              </a>
            </li>

            <li>
              <a
                href="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/Terms_and_Conditions.pdf"
                target="_blank"
                rel="noreferrer"
              >
                Terms and Conditions
              </a>
            </li>
          </ul>

          <div style={{ marginTop: 10, fontSize: 13 }}>
              <span style={{ color: "red" }}>*</span>Note: Transactions completed up to 9:00 PM will be settled on the same day. Transactions completed after 9:00 PM will be settled on T+1 working day.
          </div>
        </div>

        <Row gutter={12}>
          <Col span={12}>
            <Button
              size="large"
              block
              onClick={() => {
                form.resetFields();
                setFormData({
                  full_name: "",
                  mobile: "",
                  email: "",
                  pan: "",
                  amount: null,
                  consent: false,
                });
              }}
            >
              Cancel
            </Button>
          </Col>

          <Col span={12}>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              block
              className="rec-primary-btn"
            >
              Pay Online
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default RecRegistrationForm;